exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".IconCateg-iconCateg-3BZD6{fill:#133a7f}.IconCateg-exponent-2QEzX{background-color:#ff5766;border-radius:10px;font-weight:700;font-style:normal;padding:2px 5px;min-width:10px;line-height:20px;text-align:center;color:#fff;position:absolute;height:20px;right:10px}", ""]);

// exports
exports.locals = {
	"iconCateg": "IconCateg-iconCateg-3BZD6",
	"exponent": "IconCateg-exponent-2QEzX"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/core/components/IconCateg.less
// module id = 1649
// module chunks = 0